/****************************************
	UI
*****************************************/
const ui = {
	debounce(callback, delay, immediate) {
		return this.throttle(callback, delay, undefined, !!immediate);
	},
	deleteCookie(cookieName) {
		document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC`;
	},
	escapeRegExp(str) {
		return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	},
	focusable(element, isTabIndexNotNaN) {
		const nodeName = element.nodeName.toLowerCase();
		return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled : (nodeName === 'a') ? (element.href || isTabIndexNotNaN) : isTabIndexNotNaN) && this.visible(element);
	},
	getCookie(name) {
		const cookieName = `${name}=`;
		const cookies = document.cookie.split(';');
		const len = cookies.length;
		let cookie;
		for (let i = 0; i < len; i++) {
			cookie = cookies[i].trim();
			if (cookie.indexOf(cookieName) === 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}
		return '';
	},
	getDictionaryCookie(cookieName, entryName) {
		const cookie = this.getCookie(cookieName);
		if (!cookie.length) {
			return '';
		}
		const values = cookie.split('&');
		entryName = `${entryName}=`;
		for (let i = values.length - 1; i >= 0; i--) {
			if (values[i].indexOf(entryName) !== -1) {
				return values[i].substr(values[i].indexOf(entryName) + (entryName.length));
			}
		}
		return '';
	},
	getRandomNumber(min, max) {
		if (!isNaN(min) && !isNaN(max)) {
			return Math.floor((Math.random() * (1 + max - min)) + min);
		}
		return Date.now().toString() + Math.floor((Math.random() * 1000) + 1);
	},
	getTabbableElements($container) {
		return $container
			.find('input, select, textarea, button, a, object, [tabindex]')
			.filter((i, ele) => this.tabbable(ele));
	},
	getUrlParameterValue(param, url, caseSensitive) {
		/* Get the text between the first ? and the either the first # or the end of the url */
		const query = url ? (url.split(/\?(.+)?/)[1] || '').split(/\#(.+)?/)[0] : window.location.search.substring(1);
		const vars = query.replace(/&amp;/g, '&').split('&');
		const len = vars.length;
		for (let i = 0; i < len; i++) {
			const pair = vars[i].split('=');
			if (!caseSensitive) {
				param = param.toLowerCase();
				pair[0] = pair[0].toLowerCase();
			}
			if (decodeURIComponent(pair[0]) === param) {
				return pair[1] ? decodeURIComponent(pair[1]) : '';
			}
		}
		return undefined;
	},
	isNumber(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	},
	isValidCallback(callback) {
		return callback && $.isFunction(callback);
	},
	lang: (() => {
		const lang = document.querySelector('[lang]');
		return lang ? lang.getAttribute('lang').toLowerCase() : 'en';
	})(),
	localize(langSet, key) {
		if (langSet[this.lang] && langSet[this.lang][key]) {
			return langSet[this.lang][key];
		}
		if (langSet[this.lang.substring(0, 2)] && langSet[this.lang.substring(0, 2)][key]) {
			return langSet[this.lang.substring(0, 2)][key];
		}
		return langSet.en[key] || '';
	},
	setCookie(cookieName, value, daysUntilExpiration = 90, domain = window.location.hostname.replace(/.+?\./, '.'), path = '/') {
		const d = new Date();
		d.setTime(d.getTime() + (daysUntilExpiration * 24 * 60 * 60 * 1000));
		const expires = `expires=${d.toUTCString()}`;
		document.cookie = `${cookieName}=${value}; ${expires};domain=${domain};path=${path}`;
	},
	setDictionaryCookie(cookieName, key, value, daysUntilExpiration, domain, path) {
		cookieName = cookieName.toUpperCase();
		key = key.toUpperCase();
		let dictionary = this.getCookie(cookieName);
		if (dictionary === null || dictionary === undefined) {
			dictionary = `${key}=${value}`;
		} else {
			let dictSrc = dictionary.toLowerCase();
			const startKey = dictSrc.indexOf(`${key.toLowerCase()}=`);
			if (startKey === -1) {
				/* key was not there */
				if (dictionary.length > 0) {
					dictionary = `${dictionary}&`;
				}
				dictionary = `${dictionary}${key}=${value}`;
			} else {
				const endKey = dictSrc.indexOf('&', startKey);
				if (endKey === -1) {
					/* no keys after */
					if (startKey === 0) {
						/* no keys before and no keys after */
						dictionary = `${key}=${value}`;
					} else {
						/* keys before not after */
						dictionary = `${dictionary.substring(0, startKey)}${key}=${value}`;
					}
				} else {
					/* key is somewhere in middle */
					dictSrc = dictionary;
					dictionary = '';
					if (startKey > 0) {
						/* keys before */
						dictionary = dictSrc.substring(0, startKey);
					}
					dictionary = `${dictionary}${key}=${value}${dictSrc.substring(endKey)}`;
				}
			}
		}
		this.setCookie(cookieName, dictionary, daysUntilExpiration, domain, path);
	},
	tabbable(element) {
		const tabIndex = $.attr(element, 'tabindex');
		const isTabIndexNaN = isNaN(tabIndex);
		return (isTabIndexNaN || tabIndex >= 0) && this.focusable(element, !isTabIndexNaN);
	},
	throttle(callback, delay, noTrail, immediate) {
		let timeout;
		let previous = 0;
		function result(...args) {
			let timeoutCallback;
			let timeoutDelay;
			const elapsed = Date.now() - previous;
			const reset = () => {
				timeout = undefined;
			};
			const execute = () => {
				previous = Date.now();
				callback.apply(this, args);
			};
			if (immediate && !timeout) {
				execute();
			}
			if (timeout) {
				clearTimeout(timeout);
			}
			if (immediate === undefined && elapsed > delay) {
				execute();
			} else if (noTrail !== true) {
				timeoutCallback = immediate ? reset : execute;
				timeoutDelay = immediate === undefined ? delay - elapsed : delay;
				timeout = setTimeout(timeoutCallback, timeoutDelay);
			}
		}
		return result;
	},
	ucfirst(str) {
		return `${str.charAt(0).toUpperCase()}${str.substr(1).toLowerCase()}`;
	},
	visible(element) {
		return $.expr.filters.visible(element) && !$(element).parents().andSelf().filter((i, ele) => $.css(ele, 'visibility') === 'hidden').length;
	},
	warn(msg, useAlert) {
		if (window.console) {
			console.warn(msg);
			if (useAlert && (/ancestry(?:stage|dev)/).test(window.location.hostname)) {
				window.alert(msg);
			}
		}
	}
};
